<template>
  <!-- ログインID通知 (01_auth_and_login_api.md §4.3). Copied from ForgotPassword.vue; keeps its
       root class so login.css styles the dialog identically. -->
  <div class="forgotpassword-client forgotloginid-client">
    <el-dialog
        :visible.sync="dialogForgotLoginIdVisible"
        :show-close="false"
        :before-close="destroyOnClose"
        :close-on-click-modal="false"
        width="30%">
      <el-form
        class="forgotpassword-form"
        :model="forgotLoginIdForm"
        :rules="rules"
        ref="forgotLoginIdForm"
        @submit.native.prevent="submitForm('forgotLoginIdForm')"
        label-width="120px"
      >
        <div class="messages">
            <span>ログインIDのご案内を送ります</span><br>
            <span>ご登録されているメールアドレスか携帯電話番号（ハイフン含む）を半角で入力してください。</span><br><br>
            <span class="error">{{ this.messages }}</span>
        </div>
        <div class="login-sso-notice">
            <p class="login-sso-notice__title">
                <i class="el-icon-info login-sso-notice__icon" aria-hidden="true"></i>
                AIユイゴン&nbsp;Well-Bをご利用の方へ
            </p>
            <p class="login-sso-notice__text">
                AIユイゴン&nbsp;Well-Bをお使いの方は、AIユイゴン&nbsp;Well-Bのログイン情報をご利用頂けます。
            </p>
        </div>
        <el-form-item prop="emailOrPhone" label="送付先">
            <el-input v-model="forgotLoginIdForm.emailOrPhone" placeholder="送付先" ref="email" :autofocus="dialogForgotLoginIdVisible"></el-input>
        </el-form-item>
        <el-form-item prop="dateOfBird" label="生年月日" style="margin-top: 30px">
          <date-select v-model="forgotLoginIdForm.dateOfBird" :default-year="'1960'"></date-select>
        </el-form-item>
        <el-form-item class="recaptcha-mb">
            <vue-recaptcha ref="recaptcha" :sitekey="sitekey" @expired="markRecaptchaNotVerified" @verify="markRecaptchaAsVerified"></vue-recaptcha>
            <div class="el-form-item__error">{{ forgotLoginIdForm.recaptchaMesg }}</div>
        </el-form-item>
        <el-form-item class="text-center-mobile" style="margin-top:  30px">
            <el-button type="danger" @click="closeForm('forgotLoginIdForm')">キャンセル</el-button>
            <el-button type="primary" native-type="submit">送付する</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <SendMailSuccess :sendMailSuccessVisible='sendMailSuccessVisible' :message="successMessage" @hideSendMailSuccessModal="hideSendMailSuccessModal" />
  </div>
</template>

<script>
import Vue from 'vue'
import moment from 'moment'
import ApiPasswordRemind from '@/api/passwordremind'
import SendMailSuccess from './SendMailSuccess.vue'
import VueRecaptcha from 'vue-recaptcha'
import DateSelect from '../../../../components/common/DateSelect'
const SITE_KEY = process.env.VUE_APP_RECAPTCHA_CLIENT_SITE_KEY

export default {
  name: 'forgotloginid-client',
  components: {
        DateSelect,
        VueRecaptcha,
        SendMailSuccess
  },
  props: ['dialogForgotLoginIdVisible'],
  data () {
    // Same accepted shapes as ForgotPassword.vue (test_plan.md §7 †102).
    let validateEmailOrPhone = (rule, value, callback) => {
      const regexMail = /^\S+@\S+\.\S+$/
      const regexDomesticPhone = /^0\d{9,10}$/
      const regexE164Phone = /^\+81\d{9,10}$/
      const regexStartEmail = /^[a-zA-Z]/
      const regexStartMobilePhone = /^[\d+]/
      if (typeof value === 'undefined' || value === '') {
        callback(new Error('メールアドレス又は携帯電話番号を入力してください'))
      } else {
        let inputStr = value.trim()
        let digitsOnly = inputStr.replace(/-/g, '')
        let isPhoneShaped = regexDomesticPhone.test(digitsOnly) || regexE164Phone.test(inputStr)
        if (regexStartEmail.test(inputStr) && !regexMail.test(inputStr)) {
          callback(new Error('メールアドレスは半角英数字（@あり）で入力してください'))
        } else
        if (regexStartMobilePhone.test(inputStr) && !isPhoneShaped) {
          callback(new Error('携帯電話番号は半角数字で入力してください（例: 090-1234-5678、09012345678、+819012345678）'))
        } else
        if (!regexMail.test(inputStr) && !isPhoneShaped) {
          callback(new Error('メールアドレス又は携帯電話番号を入力してください'))
        } else {
          callback()
        }
      }
    }
    let validateDateOfBird = (rule, value, callback) => {
      if (typeof value === 'undefined') {
        callback(new Error('生年月日を入力してください'))
      } else
      if (!moment(value, 'YYYY-MM-DD', true).isValid()) {
        callback(new Error('正しい日付を選択してください'))
      } else {
        callback()
      }
    }
    return {
      sitekey: SITE_KEY,
      sendMailSuccessVisible: false,
      successMessage: 'ご登録のメールアドレス／電話番号宛に、ログインIDのご案内をお送りしました。',
      forgotLoginIdForm: {
        emailOrPhone: '',
        recaptchaVerified: false,
        recaptchaMesg: ''
      },
      messages: '',
      rules: {
        emailOrPhone: [
          { validator: validateEmailOrPhone, trigger: 'blur' }
        ],
        dateOfBird: [
          { validator: validateDateOfBird, trigger: 'blur' }
        ]
      }
    }
  },
  watch: {
    dialogForgotLoginIdVisible () {
      if (this.dialogForgotLoginIdVisible) {
        let self = this
        Vue.nextTick()
            .then(function () {
                self.$refs.email.focus()
        })
      }
    }
  },
  methods: {
    markRecaptchaAsVerified (reponse) {
      this.forgotLoginIdForm.recaptchaMesg = ''
      this.forgotLoginIdForm.recaptchaVerified = true
    },
    markRecaptchaNotVerified () {
      this.forgotLoginIdForm.recaptchaVerified = false
    },
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (!this.forgotLoginIdForm.recaptchaVerified) {
            this.forgotLoginIdForm.recaptchaMesg = '「私はロボットではありません」にチェックを入れてください'
            return true
          }

          // The endpoint always answers 200 (anti-enumeration), so success is shown regardless
          // of whether anything matched.
          ApiPasswordRemind.sendLoginIdNotification(this.forgotLoginIdForm.emailOrPhone, this.forgotLoginIdForm.dateOfBird).then(response => {
            if (response.status === 200) {
              this.sendMailSuccessVisible = true
              this.closeForm('forgotLoginIdForm')
            }
          }).catch(err => {
            var status = err.response.status
            if (status === 400 || status === 404) {
              this.messages = '該当の会員が存在しません。'
            } else if (status === 401) {
              this.messages = 'アクセストークンの有効期限切れです。'
            } else if (status === 403) {
              this.messages = 'Forbidden'
            } else {
              this.messages = 'Internal Server Error'
            }
          })
        } else {
          return false
        }
      })
    },
    closeForm (formName) {
      this.destroyOnClose()
      this.$refs['forgotLoginIdForm'].resetFields()
      this.messages = ''
    },
    destroyOnClose () {
      this.$emit('hideForgotLoginIdModal', false)
      this.forgotLoginIdForm = {
        recaptchaVerified: false,
        recaptchaMesg: ''
      }
      this.$refs.recaptcha.reset()
    },
    hideSendMailSuccessModal (val) {
      this.sendMailSuccessVisible = val
    }
  }
}
</script>

<style scoped>
    @import './login.css';
</style>
